import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { axiosBeelineRequest } from '@beef/utils';
import { getUserType } from "../../../../../components/PaymentContainer/components/PaymentSelection/components/PaymentDetailsSection/InputSection/components/PhoneInput/utils";
import { EPaymentStatusConstant } from "../../../../checkUrl/constants";
import { UserAccountInfo } from "../../../../getUserAccountInfo/UserAccountInfo";
import { getRequestIds } from "../../../transaction/utils";
import { checkIsClientSide } from "../../../../../utils/utils";
import { EUserType } from "../../../../../../constants";
import { redirect } from "../../../../../../utils/redirect";
import { sessionStateMap } from "../../../../checkUrl/persistence/map.dev";
import { getTransactionState, setTransactionState } from "../../../transaction";
import { EPaymentSource } from "../constants";
import { getUrl } from "../../utils";
export var sendCardPayment = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var _sessionStateMap$save;
    var _ref$orderData, orderDate, sum, ctn, payeePhone, _ref$loginData, isAuthenticated, loginUrl, bindingId, smsCode, data, _UserAccountInfo$getI, email, accountType, receiptPhone, receiptEmail, _yield$axiosBeelineRe, _yield$axiosBeelineRe2, _yield$axiosBeelineRe3, formUrl, status, verificationId, externalId, responseStatus;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _ref$orderData = _ref.orderData, orderDate = _ref$orderData.orderDate, sum = _ref$orderData.sum, ctn = _ref$orderData.ctn, payeePhone = _ref$orderData.payeePhone, _ref$loginData = _ref.loginData, isAuthenticated = _ref$loginData.isAuthenticated, loginUrl = _ref$loginData.loginUrl, bindingId = _ref.bindingId, smsCode = _ref.smsCode;
          if (!(!isAuthenticated && checkIsClientSide())) {
            _context.next = 5;
            break;
          }
          _context.next = 4;
          return redirect(loginUrl, window);
        case 4:
          return _context.abrupt("return", undefined);
        case 5:
          data = getTransactionState();
          _UserAccountInfo$getI = UserAccountInfo.getInstance().getData(), email = _UserAccountInfo$getI.email;
          accountType = getUserType(ctn);
          receiptPhone = accountType === EUserType.Mobile ? ctn : undefined;
          receiptEmail = accountType === EUserType.Fttb ? email : undefined;
          (_sessionStateMap$save = sessionStateMap.saveSum) === null || _sessionStateMap$save === void 0 || _sessionStateMap$save.save();
          _context.next = 13;
          return axiosBeelineRequest({
            url: '/api/v1/payment/register',
            method: 'post',
            originalResponse: true,
            data: _objectSpread({
              failUrl: getUrl([[EPaymentStatusConstant.StatusParameter, EPaymentStatusConstant.Failure]]),
              returnUrl: getUrl([[EPaymentStatusConstant.StatusParameter, EPaymentStatusConstant.Success]]),
              backToShopUrl: getUrl([]),
              ctn: ctn,
              orderDate: orderDate,
              amount: sum,
              paymentSource: EPaymentSource.BankCard,
              payeePhone: payeePhone,
              bindingId: bindingId,
              smsCode: smsCode,
              receiptPhone: receiptPhone,
              receiptEmail: receiptEmail
            }, getRequestIds(data, typeof smsCode === 'number'))
          });
        case 13:
          _yield$axiosBeelineRe = _context.sent;
          _yield$axiosBeelineRe2 = _yield$axiosBeelineRe.data;
          _yield$axiosBeelineRe3 = _yield$axiosBeelineRe2 === void 0 ? {} : _yield$axiosBeelineRe2;
          formUrl = _yield$axiosBeelineRe3.formUrl;
          status = _yield$axiosBeelineRe3.status;
          verificationId = _yield$axiosBeelineRe3.verificationId;
          externalId = _yield$axiosBeelineRe3.externalId;
          responseStatus = _yield$axiosBeelineRe.status;
          if (!(responseStatus !== 200 && !status)) {
            _context.next = 23;
            break;
          }
          throw new Error('unsuccessful response');
        case 23:
          _context.next = 25;
          return setTransactionState({
            verificationId: verificationId,
            externalId: externalId
          }, status || undefined);
        case 25:
          if (!(formUrl && !status)) {
            _context.next = 29;
            break;
          }
          _context.next = 28;
          return redirect(formUrl, window);
        case 28:
          return _context.abrupt("return", undefined);
        case 29:
          return _context.abrupt("return", status);
        case 30:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function sendCardPayment(_x) {
    return _ref2.apply(this, arguments);
  };
}();